var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { BaseInput } from '../ui';
import { FormField } from './form-field';
export const TextInputField = forwardRef((_a, ref) => {
    var { label, error, description, width, isRequired = false, labelClassName = '', tooltip, type = 'text' } = _a, props = __rest(_a, ["label", "error", "description", "width", "isRequired", "labelClassName", "tooltip", "type"]);
    const id = useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, labelVariant: 'label', width: width, labelClassName: labelClassName, tooltip: tooltip, containerClassName: width !== null && width !== void 0 ? width : 'w-full', isRequired: isRequired, children: _jsx(BaseInput, Object.assign({ ref: ref, id: id, type: type, hasError: !!error, style: {
                borderColor: error ? '#EF4444' : '',
            } }, props, { className: `!w-full !px-2 !py-2 !text-gray-700 !border !border-gray-300 !rounded-md hover:!border-vjwPrimary focus:!outline-none focus:!border-vjwPrimary ${(props === null || props === void 0 ? void 0 : props.className) || ''}` })) }));
});
TextInputField.displayName = 'TextInputField';
